import { type ComponentInternalInstance, getCurrentInstance } from 'vue'

import { closePopWindowById, closePopWindowByTag, initPopWindow, showPopWindow } from './src/index'
import { type PopWindowInfoProps, type PopWindowProps } from './src/interface'

export { showPopWindow, closePopWindowById, closePopWindowByTag }
export type { PopWindowInfoProps, PopWindowProps }
export const usePopWindow = (ctx?: any) => {
  const thisAppContext = ctx || (getCurrentInstance() as ComponentInternalInstance)
  const { showPopWindow } = initPopWindow(thisAppContext)
  return { showPopWindow }
}
